import { render, staticRenderFns } from "./FaqEditPage.vue?vue&type=template&id=f85d9fea"
import script from "./FaqEditPage.vue?vue&type=script&lang=ts"
export * from "./FaqEditPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports